import { Product } from "src/app/views/common/models/product_model";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { RouteInfo } from "src/app/shared/sidebar/sidebar.metadata";

@Injectable({
  providedIn: "root",
})
export class OpAdminProductListService {
  constructor(private http: HttpClient) {}
  setHeader() {
    let headers = new HttpHeaders();
    headers = headers.set("Content-Type", "application/json; charset=utf-8");
    return headers;
  }

  private sidebarnavItems: RouteInfo[] = [];
  myHeaders = this.setHeader();

  getAllUser(pageId) {
    let url = environment.URL + "/product/getall?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  ProductListRecordById(productId) {
    let url = environment.URL + "/product/edit/" + productId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getImagesByProduct(productId, storeType, is360, isZoomImage, isVideoUrl) {
    let url =
      environment.URL +
      "/productImages/" +
      productId +
      "/" +
      storeType +
      "/" +
      is360 +
      "/" +
      isZoomImage +
      "/" +
      isVideoUrl;
    return this.http.get(url, { headers: this.myHeaders });
  }

  saveProductList(formData) {
    let url = environment.URL + "/product/create";
    return this.http.post(url, formData);
  }

  getPriceFieldsFromTemplate(templateId) {
    let url = environment.URL + "/template/priceField/" + templateId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  getPriceTemplate(templateFieldId) {
    let url = environment.URL + "/template/getProductPrice/" + templateFieldId;
    return this.http.get(url, { headers: this.myHeaders });
  }

  updateProductList(formData) {
    let url = environment.URL + "/product/update";
    return this.http.post(url, formData);
  }

  deleteProductList(bodyParams: Product) {
    let url = environment.URL + "/product/delete/" + bodyParams.id;
    return this.http.get(url, { headers: this.myHeaders });
  }

  tableSearch(value, column, pageId) {
    let url =
      environment.URL + "/product/" + value + "/" + column + "?page=" + pageId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  getTemplateList() {
    let url = environment.URL + "/template/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }
  getCategoriesList() {
    let url = environment.URL + "/categories/getall";
    return this.http.get(url, { headers: this.myHeaders });
  }
  getProdcutList() {
    let url = environment.URL + "/product/all";
    return this.http.get(url, { headers: this.myHeaders });
  }
  retrievePermission() {
    return JSON.parse(sessionStorage.getItem("userRolesNPermissions"));
  }
  deleteImage(id, field, imageName) {
    let url =
      environment.URL +
      "/product/deleteImage/" +
      id +
      "/" +
      field +
      "/" +
      imageName;
    return this.http.get(url, { headers: this.myHeaders });
  }
  deleteAllImage(id, field) {
    let url = environment.URL + "/product/deleteAllImage/" + id + "/" + field;
    return this.http.get(url, { headers: this.myHeaders });
  }
  getCodeList(typeName) {
    let url = environment.URL + "/code/" + typeName;
    return this.http.get(url, { headers: this.myHeaders });
  }
  productListing(id, pageId, sort, order, search, storeType) {
    let ImageType =
      sessionStorage.getItem("ImageTypeToPurchase") != undefined &&
      sessionStorage.getItem("ImageTypeToPurchase") != null
        ? sessionStorage.getItem("ImageTypeToPurchase")
        : null;
    let url =
      environment.URL +
      "/product/listing/" +
      id +
      "/" +
      sort +
      "/" +
      order +
      "/" +
      search +
      "/" +
      storeType +
      "/" +
      ImageType +
      "?page=" +
      pageId +
      "&search=" +
      search;
    return this.http.get(url, { headers: this.myHeaders });
  }
  cartListing(productsId) {
    let url = environment.URL + "/cart/" + productsId;
    return this.http.get(url, { headers: this.myHeaders });
  }
  getMountCost(productId) {
    let url = environment.URL + "/getMountCost/" + productId;
    return this.http.get(url, { headers: this.myHeaders });
  }
}
